module.exports = __webpack_public_path__ + "img/solar-panel-icon.c9773bd2.svg";